import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react';

const Protected_Routes_without_Login = (props) => {
    const { Component } = props
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        let User_Login = localStorage.getItem("user_is_active")
        if (!User_Login) {
            localStorage.setItem("redirect_after_login", location.pathname + location.search);
            navigate("/user-login")
        }

    }, [navigate, location])
    return (
        <div>
            <Component />
        </div>
    )
}

export default Protected_Routes_without_Login